import axiosInstance from '../axios/axiosInstance'

export async function getProfileAdministrationAPI () {
  const response = await axiosInstance.get(
    '/profileadministration'
  )
  return response
}
